import { ApiAction, ApiActionName } from "./ApiAction";
import qs from "qs";

export function getHotelLocation(locationCode: string, locationType: string): ApiAction {
  return {
    method: "get",
    name: ApiActionName.GetHotelLocation,
    url: `${process.env.REACT_APP_HOTEL_LOCATION_API_URL}?${qs.stringify({
      locationCode,
      locationType,
    })}`,
  };
}
